var _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAspenLogoAnimated(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: 2282.6531,
    height: 396.60199,
    viewBox: "0 0 2282.6531 396.60199",
    enableBackground: "new 0 0 2500 2500",
    xmlSpace: "preserve",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3",
    transform: "translate(-108.56185,-1051.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4456",
    d: "m 141.643,1088.138 56.276,0 26.536,215.351 -36.86,0 -5.525,-46.237 -32.658,0 -6.147,46.237 -32.969,0 31.347,-215.351 0,0 0,0 z",
    className: "VQaCpWYW_0 tQWiowrG_0",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 3,
      strokeDasharray: "687, 689",
      strokeDashoffset: 688
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4454",
    d: "m 178.516,1223.957 -12.295,-104.771 -12.918,104.771 25.213,0 z",
    className: "VQaCpWYW_1 tQWiowrG_1",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 3,
      strokeDasharray: "237, 239",
      strokeDashoffset: 238
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4452",
    d: "m 291.716,1241.401 c 0,3.565 -0.337,4.525 -0.337,7.119 0,18.431 5.512,27.158 17.146,27.158 10.337,0 17.769,-9.039 17.769,-21.011 0,-13.903 -5.811,-22.632 -25.537,-38.481 -21.011,-16.82 -30.712,-28.806 -37.184,-45.589 -3.618,-8.941 -5.485,-18.497 -5.5,-28.144 0,-34.279 21.997,-58.857 52.709,-58.857 30.738,0 49.804,22.658 49.804,58.857 l 0,6.484 -34.59,0 0,-2.282 -0.337,-2.581 c 0,-18.432 -4.852,-26.835 -15.512,-26.835 -9.702,0 -16.188,7.756 -16.188,19.39 0,12.62 4.229,18.768 27.833,39.145 21.335,18.754 29.739,28.104 35.238,39.777 4.188,8.702 6.459,20.051 6.459,31.349 0,36.886 -21.971,60.802 -56.263,60.802 -32.347,0 -51.75,-22.956 -51.75,-61.113 l 0,-5.188 36.24,0 0,0 0,0 z",
    className: "VQaCpWYW_2 tQWiowrG_2",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 3,
      strokeDasharray: "857, 859",
      strokeDashoffset: 858
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4450",
    d: "m 407.471,1088.138 48.832,0 c 26.834,0 30.712,0.959 41.063,9.364 13.904,11.322 20.361,27.819 20.361,52.385 0,29.752 -7.443,48.507 -22.632,58.208 -10.661,6.783 -19.064,8.729 -37.833,8.729 l -8.729,0 0,86.664 -41.063,0 10e-4,-215.35 0,0 z",
    className: "VQaCpWYW_3 tQWiowrG_3",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 3,
      strokeDasharray: "607, 609",
      strokeDashoffset: 608
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4448",
    d: "m 451.775,1183.854 c 19.053,0 25.85,-7.771 25.85,-29.117 0,-25.538 -6.148,-34.279 -24.254,-34.279 l -4.838,0 0,63.396 3.242,0 z",
    className: "VQaCpWYW_4 tQWiowrG_4",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 3,
      strokeDasharray: "166, 168",
      strokeDashoffset: 167
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4446",
    d: "m 558.607,1088.138 92.177,0 0,32.32 -51.114,0 0,54.966 37.509,0 0,34.305 -37.509,0 0,61.438 51.114,0 0,32.333 -92.177,0 0,-215.362 z",
    className: "VQaCpWYW_5 tQWiowrG_5",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 3,
      strokeDasharray: "793, 795",
      strokeDashoffset: 794
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4444",
    d: "m 694.855,1088.138 36.886,0 38.157,105.742 0,-105.742 31.359,0 0,215.362 -31.047,0 -43.968,-122.862 0,122.862 -31.388,0 10e-4,-215.362 0,0 0,0 z",
    className: "VQaCpWYW_6 tQWiowrG_6",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 3,
      strokeDasharray: "1033, 1035",
      strokeDashoffset: 1034
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4442",
    d: "m 1178.719,1241.401 c 0,3.565 -0.338,4.525 -0.338,7.119 0,18.431 5.499,27.158 17.146,27.158 10.35,0 17.78,-9.039 17.78,-21.011 0,-13.903 -5.836,-22.632 -25.551,-38.481 -21.011,-16.82 -30.712,-28.806 -37.171,-45.589 -3.624,-8.939 -5.491,-18.495 -5.499,-28.144 0,-34.279 21.983,-58.857 52.709,-58.857 30.738,0 49.83,22.658 49.83,58.857 l 0,6.484 -34.616,0 0,-2.282 -0.338,-2.581 c 0,-18.432 -4.851,-26.835 -15.512,-26.835 -9.701,0 -16.173,7.756 -16.173,19.39 0,12.62 4.202,18.768 27.807,39.145 21.349,18.754 29.753,28.104 35.252,39.777 4.202,8.702 6.472,20.051 6.472,31.349 0,36.886 -21.971,60.802 -56.274,60.802 -32.334,0 -51.749,-22.956 -51.749,-61.113 l 0,-5.188 36.225,0 0,0 0,0 z",
    className: "VQaCpWYW_7 tQWiowrG_7",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 3,
      strokeDasharray: "857, 859",
      strokeDashoffset: 858
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4440",
    d: "m 1294.499,1088.138 36.848,0 38.157,105.742 0,-105.742 31.36,0 0,215.362 -31.036,0 -43.968,-122.862 0,122.862 -31.361,0 0,-215.362 z",
    className: "VQaCpWYW_8 tQWiowrG_8",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 3,
      strokeDasharray: "1033, 1035",
      strokeDashoffset: 1034
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4438",
    d: "m 1567.591,1195.813 c 0,78.597 -17.756,111.89 -59.83,111.89 -42.021,0 -59.804,-33.293 -59.804,-111.89 0,-78.571 17.782,-112.216 59.804,-112.216 42.074,0 59.83,33.645 59.83,112.216 z",
    className: "VQaCpWYW_9 tQWiowrG_9",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 3,
      strokeDasharray: "607, 609",
      strokeDashoffset: 608
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4436",
    d: "m 1614.158,1088.138 36.848,0 38.157,105.742 0,-105.742 31.36,0 0,215.362 -31.036,0 -43.968,-122.862 0,122.862 -31.361,0 0,-215.362 z",
    className: "VQaCpWYW_10 tQWiowrG_10",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 3,
      strokeDasharray: "1033, 1035",
      strokeDashoffset: 1034
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4434",
    d: "m 1817.716,1088.138 36.848,0 38.157,105.742 0,-105.742 31.36,0 0,215.362 -31.036,0 -43.968,-122.862 0,122.862 -31.361,0 0,-215.362 z",
    className: "VQaCpWYW_11 tQWiowrG_11",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 3,
      strokeDasharray: "1033, 1035",
      strokeDashoffset: 1034
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4432",
    d: "m 2021.274,1088.138 36.848,0 38.157,105.742 0,-105.742 31.36,0 0,215.362 -31.036,0 -43.968,-122.862 0,122.862 -31.361,0 0,-215.362 z",
    className: "VQaCpWYW_12 tQWiowrG_12",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 3,
      strokeDasharray: "1033, 1035",
      strokeDashoffset: 1034
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4430",
    d: "m 2224.832,1088.138 36.848,0 38.157,105.742 0,-105.742 31.36,0 0,215.362 -31.036,0 -43.968,-122.862 0,122.862 -31.361,0 0,-215.362 z",
    className: "VQaCpWYW_13 tQWiowrG_13",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 3,
      strokeDasharray: "1033, 1035",
      strokeDashoffset: 1034
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAspenLogoAnimated);
export default __webpack_public_path__ + "static/media/aspen_logo_animated.d2cf572e8f58bf1155c361b3d69b66d6.svg";
export { ForwardRef as ReactComponent };